<template>
<div>
    <sav-rgpd-modal />
    <sav-template :title="'Inscription'">
        <div v-if="$route.query.next" class="p-3 mb-3 font-light bg-orange-100 border border-orange-200 my-rounded">
            <i class="mr-1 fa-solid fa-triangle-exclamation"></i> {{$t('inscription.vous_devez_etre_authentifie_pour_continuer_la_procedure')}}
        </div>
        <div class="p-6 mt-3 bg-white shadow my-rounded">
            <div class="hide-on-mobile">
                <h2 class="text-xl font-bold">{{$t('inscription.creer_un_nouveau_compte')}}</h2>
                <span class="text-sm font-light">{{$t('inscription.inscrivez_vous')}}</span>
                <hr class="my-3">
            </div>
            <template v-for="(item, index) in form">
                <div :key="index">
                    <sav-input class="mb-3" :label="item.label" :type="item.type" :errors="item.errors" v-model="item.value" />
                </div>
            </template>
            <!-- Password -->
            <div class="mb-3">
                <sav-input-password :errors="errorsPassword" v-model="password" />
            </div>

            <!-- Rgpd -->
            <div class="flex items-center my-5 font-light" :class="errorValidCondition ? 'text-red-500' : ''">
                <input v-model="acceptRgpd" type="checkbox" class="w-4 h-4 mr-3 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500" id="accept_rgpd" /> <label for="accept_rgpd">{{$t('inscription.j_accepte_les')}} <button class="ml-0 underline" @click="$modal.show('rgpd-modal')">{{$t('inscription.conditions_d_utilisation_btn')}}</button> <span v-if="$t('inscription.conditions_d_utilisation_more') != 'inscription.conditions_d_utilisation_more'" v-html="$t('inscription.conditions_d_utilisation_more')"></span></label>
            </div>
            <div v-if="errorValidCondition" class="text-red-600 font-bold rounded -mt-3 ml-6 mb-5">
                {{$t('inscription.vous_devez_accepter_les_conditions_d_utilisation')}}
            </div>
            <!-- Newsletter -->
            <div v-if="$companyTool.confFile().newsletter == 1" class="flex my-5 font-light items-center">
                <input v-model="acceptNewsletter" type="checkbox" class="w-4 h-4 mr-3 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500" id="accept_newsletter" /> <label v-html="$t('inscription.je_m_inscris_a_la_newsletter')" for="accept_newsletter"></label>
            </div>
            <div>
                <button test-id="button-register" :disabled="loading" @click="submit" class="px-4 py-2 font-bold text-white duration-100 bg-sky-500 hover:bg-sky-600 rounded-xl">
                    <template v-if="loading">
                        <sav-spinner />
                    </template>
                    <template v-else><i class="fas fa-check mr-1"></i> {{ $tt("S'inscrire") }}</template>
                </button>
            </div>
            <div>
                <div class="mt-4 text-xs font-light">En renseignant les données personnelles demandez, vous consentez à ce que ces données soient collectées et traitées selon les dispositions de notre <a :href="$companyTool.confFile().url_politique ? $companyTool.confFile().url_politique : 'https://disticloudfiles.net/upload/files/Politique%20de%20confidentialite%20-%20SAVLOG.pdf'" class="underline" target="_blank">politique de confidentialité</a> et les réglementations en vigueur</div>
            </div>
        </div>
        <div class="mt-3 text-secondary">
            <!-- <div class="text-sm font-light">{{$t('inscription.en_creant_votre_compte_vous_acceptez')}} <button class="ml-0 text-gray-800 underline" @click="$modal.show('rgpd-modal')">{{$t('inscription.les_conditions_d_utilisation')}}</button></div> -->
            <small class="mt-3 d-block"> {{$t('inscription.vous_avez_deja_un_compte_?')}}
                <router-link :to="{ name: 'user.login', query: {next: this.redirect} }">
                    <b test-id="go-to-login">
                        <u>{{$t('inscription.connectez_vous')}}</u>
                    </b>
                </router-link>
            </small>
        </div>
    </sav-template>
</div>
</template>

<script>
import sha256 from 'js-sha256';
import apiService from '@/services/api.service';
import SavInputPassword from '@/components/SavInputPassword'
import SavRgpdModal from '@/components/SavRgpdModal'
export default {
    components: {SavInputPassword, SavRgpdModal},

    data() {
        return {
            loading: false,
            password: null,
            acceptRgpd: false,
            acceptNewsletter: false,
            errorsPassword: [],
            errorValidCondition: false,
            form: [
                {
                    label: this.$t('inscription.nom'),
                    key: 'lastName',
                    type: 'text',
                    errors: [],
                    value: '',
                    required: true
                },
                {
                    label: this.$t('inscription.prenom'),
                    key: 'firstName',
                    type: 'text',
                    errors: [],
                    value: '',
                    required: true
                },
                {
                    label: this.$t('inscription.email'),
                    key: 'email',
                    type: 'email',
                    errors: [],
                    value: '',
                    required: true
                },
                {
                    label: this.$tt('Téléphone'),
                    key: 'tel',
                    type: 'tel',
                    errors: [],
                    value: '',
                    required: false
                }
            ],
            redirect: ''
        }
    },

    methods: {
        validations: function() {
            let hasError = false;

            const regexEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

            this.form.forEach(item => {
                item.errors = []
                if (item.required && !item.value) {
                    item.errors.push(this.$t('inscription.champ_incomplet'))
                    hasError = true
                }
                if (item.type === 'email') {
                    if (!regexEmail.test(item.value)) {
                        item.errors.push(this.$t('inscription.veuillez_entrer_un_email_valide'))
                        hasError = true
                    }
                }
                if (item.key == 'firstName' || item.key == 'lastName') {
                    let nameIsCorrect = /^[a-zA-ZÀ-ÿ\s\-]+$/.test(item.value);
                    if (!nameIsCorrect) {
                        hasError = true
                        if (item.key == 'firstName') {
                            item.errors.push(this.$tt('Prénom incorrect'))
                        } else {
                            item.errors.push(this.$tt('Nom incorrect'))
                        }
                    }
                }
                if (item.key == 'tel') {
                    let telValue = document.querySelector('input[type=tel]').value
                    if (telValue && !item.value) {
                        item.errors.push(this.$tt('Numéro de téléphone incorrect'))
                    }
                }
            })

            if (!this.password || (this.password && !this.password.valid)) {
                hasError = true
                if (!this.password) {
                    this.errorsPassword = [this.$tt('Mot de passe obligatoire')]
                } else {
                    this.errorsPassword = [this.$tt('Mot de passe incorrect')]
                }
            } else {
                this.errorsPassword = []
            }

            if (!this.acceptRgpd) {
                hasError = true
                this.errorValidCondition = true
            } else {
                this.errorValidCondition = false
            }
            console.log(this.errorValidCondition);
            
            return !hasError
        },
        getValueByKey(keyname) {
            return this.form.find(item => item.key === keyname).value
        },
        async submit() {
            if (this.validations()) {
                this.loading = true
                let response = await apiService.post('setlogin', {
                    nom: this.getValueByKey('lastName'),
                    prenom: this.getValueByKey('firstName'),
                    mail: this.getValueByKey('email'),
                    tel: this.getValueByKey('tel'),
                    password: sha256(this.password.password),
                    newsletter: this.acceptNewsletter ? 1 : 0
                })
                if (response.data.posts.post) {
                    localStorage.setItem('client_id', this.$crypto.encrypt(response.data.posts.post))

                    if (!this.redirect) {
                        this.$router.push({name: 'home'})
                    } else {
                        this.$router.push({name: this.redirect})
                    }
                }
                this.loading = false
            }
        }
    },

    mounted() {
        let client_id = this.$crypto.decrypt(localStorage.getItem('client_id'))
        this.redirect = this.$route.query.next

        if (client_id) {
            this.$router.push({name: this.redirect || 'home'})
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/companies/default/views/user/Register.vue